import BaseViewController from "./base-view-controller";

const FIELDS_WITH_AUXILIARY_IDS = ["mhd_answer_ids.75", "mhd_answer_ids.234"];

class MedicalHistoryViewController extends BaseViewController {
  formState = {};

  prepareSubmit(values) {
    const auxiliaryIdsFixes = FIELDS_WITH_AUXILIARY_IDS.reduce(
      (fixes, name) =>
        values[name]
          ? {
              ...fixes,
              [name]: `${parseInt(values[name], 10)}`
            }
          : fixes,
      {}
    );
    return {
      ...super.prepareSubmit(values),
      ...auxiliaryIdsFixes,
      ...this.formState
    };
  }

  fetchPdf(action) {
    this.appData.fetchPostFile({
      openInNewTab: !this.appData.disableAttachmentsInNewTab,
      url: action.value,
      preparedData: { ...this.formState, ...action.data },
      fileName: this.appData.settings.translations.medical_history
    });
  }

  handleButtonClick(name, text, buttonAction) {
    switch (name) {
      case "downloadCCR":
        this.fetchPdf(buttonAction);
        break;

      case "addAllergyLink":
        this.dialog.showDialog({
          content: {
            title: this.appData.settings.translations.new_allergy_type
          },
          actions: [
            {
              label: this.appData.settings.translations.drug,
              onClick: () =>
                super.handleButtonClick(name, text, {
                  type: "screen",
                  value: "SearchAllergyModal"
                })
            },
            {
              label: this.appData.settings.translations.food_other,
              onClick: () => {
                this.formState = {
                  allergy_reaction: "",
                  statusQuestion: "Y"
                };
                super.handleButtonClick(name, text, {
                  type: "screen",
                  value: "AddAllergyOther"
                });
              }
            },
            { label: this.appData.settings.translations.cancel }
          ]
        });
        break;
      default:
        super.handleButtonClick(name, text, buttonAction);
    }
  }

  preprocessScreenData() {
    const otherField = this.screen.fields.find(
      field => field.name === "mhd_answers.75"
    );
    if (otherField) {
      otherField.name = "mhd_answer_ids.75";
      otherField.options = [
        {
          name: "Y",
          value: "70_Y",
          selected: !!otherField.text,
          text: this.appData.values["mhd_answers.75"] || ""
        },
        {
          name: "N",
          text: "",
          value: "70",
          selected: !otherField.text
        }
      ];
      this.appData.handleChange({
        "mhd_answer_ids.75": otherField.text ? "70_Y" : "70"
      });
    }
    // Other Family Issues field on minor dependants
    const otherFieldMinor = this.screen.fields.find(
      field => field.name === "mhd_answer_ids.234"
    );
    if (otherFieldMinor && !this.appData.values["mhd_answer_ids.234"]) {
      otherFieldMinor.options = [
        {
          name: "N",
          text: "",
          value: "533_N",
          selected: false
        },
        ...otherFieldMinor.options.map(f => ({ ...f, name: "Y" }))
      ];
      this.appData.handleChange({
        "mhd_answer_ids.234": otherFieldMinor.text ? "533" : "533_N",
        "mhd_answers.234": otherFieldMinor.text
      });
    }
    super.preprocessScreenData();
  }
}

export default MedicalHistoryViewController;
